module.exports = __webpack_public_path__ + "static/media/isaca.375dc797.png";